/* eslint no-underscore-dangle: ["error", { "allow": ["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] }] */
/* eslint import/no-extraneous-dependencies: off */

import {
  createStore, compose, combineReducers, applyMiddleware,
} from 'redux';
import createSagaMiddleware from 'redux-saga';
import {thunk} from 'redux-thunk';
import {createBrowserHistory} from 'history';

import mapReducer from './reducers/map';
import uiReducer from './reducers/ui';
import userReducer from './reducers/user';
import docReducer from './reducers/doc';
import commonReducer from './reducers/common';
import crmReducer from './reducers/crm';
import watchActions from './sagas';

export const history = createBrowserHistory();

const rootReducer = combineReducers({
  map: mapReducer,
  ui: uiReducer,
  user: userReducer,
  doc: docReducer,
  common: commonReducer,
  crm: crmReducer,
});
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk, sagaMiddleware)));

sagaMiddleware.run(watchActions);

export default store;
